/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import ReactHtmlParser from 'react-html-parser';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Avatar, Box, Button, Drawer, IconButton, Link } from '@mui/material';
import { setLoadingState } from '../../actions/actions';
import appSettings from '../../appSettings';
import { gwLinkRedirect } from '../../common/services/proxyServices';
import { getCurrentPrismId } from '../../common/utilities/CommonHelperUtil';
import logo from './../../common/assets/img/AMIG-logo-withTagline.png';
import { useFormSubmit } from '../../utils/useFormSubmit';
import constants from '../../constants';
import './MobileMenuButton.scss';

const MobileMenuButton = (props) =>  {
    const history = useHistory();
    const { instance } = useMsal();
    const contactData = useSelector(state => state.contact);
    const loading = useSelector(state => state.loading);
    const [expanded, setExpanded] = useState(null);
    let firstNameInitial = null;
    let lastNameInitial = null;
    const [initials, setInitials] = useState(null);
    const agentAMSuitePreference = useSelector(state=> state.selectedProfile.amsuitePreference);
    const enrollments = useSelector(state => state.enrollments);
    const username = enrollments.length > 0 ? getCurrentPrismId(enrollments) : ''; 
    const legacyProfileId = useSelector(state=> state.selectedProfile.lpId);
    const message = contactData.firstName + " " + contactData.lastName + "\t" + legacyProfileId;
    const encodedMessage = encodeURIComponent(message);

    const { formRef, inputRef, handleSubmit } = useFormSubmit(encodedMessage);

  useEffect(() => {
    setLoadingState(true);
    if (Object.keys(contactData).length !== 0) {
        firstNameInitial = contactData.firstName.charAt(0);
        lastNameInitial = contactData.lastName.charAt(0);     
        setInitials(`${firstNameInitial}${lastNameInitial}`);
        setLoadingState(false);
    }
  }, [contactData, loading]);
  

    const toggleAccordion = (index) => {
        if (expanded === index) {
            setExpanded(null); // Collapse the current accordion if it's already expanded
        } else {
            setExpanded(index); // Expand the clicked accordion
        }
    };

    function logout() {
        instance.logout();
    }

    const handleMenuItemClick = (submenu, index) => {
        if (submenu.link !== '') {
          if(history.location.pathname !== '/') {
               window.location.replace(`${submenu.link}?dropdown=true`);  
          } else {
              props.toggleDropdown();
          }
          toggleAccordion(index);
          props.toggleSidebar();
        } else {
        }
      };


      const handleNavigate = async () => {
        if (username) {
            const newURL = agentAMSuitePreference !== undefined && agentAMSuitePreference.toLowerCase() !== constants.amsuite 
                ? await gwLinkRedirect(username, null, false, true) 
                : await gwLinkRedirect(username, null, true, false);
            if (newURL) {
                window.open(newURL, '_self');
            }
        }
    };

    const createNotificationBlock = (item) => {
        const notificationBorderType = item.tags && item.tags.includes('AGSS_ALERT_CRITICAL') ? 'notification-border critical' : 'notification-border';
        const notificationBlock = (
            <>
                <Box className='notification-box'>
                    <Box className={notificationBorderType} />
                    <Box className='notification-content'>
                        <Box className='notification-header'>
                            <span className='notification-title'>{ReactHtmlParser(item.title.rendered)}</span>
                            <span className='notification-date'>{new Date(item.date).toLocaleDateString()}</span>
                        </Box>
                        <Box className='notification-desc'>{ReactHtmlParser(item.content.rendered)}</Box>
                    </Box>
                </Box>
                <Box className='dropdownSeparator' />
            </>
        );

        return notificationBlock;
    };

    const handleToggles = () => {
        props.toggleSidebar();
        props.toggleChatbot();
    }

    return (
        <Drawer
            open={props.showDrawer}
            PaperProps={{
                className: props.notifications ? 'notifications-mobile-sidebar-container' : 'mobile-sidebar-container'
            }}
        >
            <Box className={props.showMinifiedHeader?'min-mobile-sidebar-header':'mobile-sidebar-header'}>
                <img
                    className="mobile-logo"
                    src={logo}
                    alt="American Modern Logo"
                />
                {!props.showMinifiedHeader && <>
                    <img
                        onClick={() => { toggleAccordion(null); props.toggleSidebar(constants.notification) }}
                        className={props.notifications ? 'active-icon' : ''}
                        src={require(`../../common/assets/img/bell-icon.png`)}
                        alt="notification"
                    />
                    <div className={props.hasNotifications ? 'sidebar-badge' : 'no-sidebar-badge'}></div>
                </>}

                <IconButton onClick={() => {toggleAccordion(null); props.toggleSidebar()}}>
                    <CloseIcon className='close-sidebar'/>
                </IconButton>
            </Box>
            <Box className='mobile-menu-section'>
            {(props.notifications &&
                <>
                    <Box className='sidebar-notifications-title-box'>
                        <div className="sidebarAvatarMenu notifications-title">Notifications ({props.notifications.length}{props.hasNotifications ? ' messages' : ''})</div>
                    </Box>
                    <div className='sidebar-notications-divider' />                     
                    {(props.notifications.length > 0) && 
                        <>
                            {(props.notifications.length > 0) && props.notifications.map((notificationItem, menuItemIndex) => (
                                <Box key={menuItemIndex}>
                                {
                                    createNotificationBlock(notificationItem)
                                }
                                </Box>
                            ))}
                        </>
                    }
                </>
            )}
            {(props.usernames && props.usernames.length > 0) && 
            <>
            {(props.usernames.length < 2) &&
                    <Box key="username" className='sidebarAvatar'>
                        <Avatar className='mobile-Avatar'>{initials}</Avatar>
                        {contactData.firstName} {contactData.lastName}
                    </Box>
                }
            {props.usernames.length > 1 && 
                    <Accordion className='mobile-menu-accordion sidebarAvatarMenu' expanded={expanded === -2}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon className={expanded === -2 ? 'expanded-menu ' : 'collapsed-menu'} />}
                            className={'avatar-menu'}
                            onClick={() => toggleAccordion(-2)}>
                            <Box key="username" className='avatar-menu-title'><Avatar className='mobile-Avatar'>{initials}</Avatar>
                                {contactData.firstName} {contactData.lastName} </Box>
                        </AccordionSummary>
                        <Box className='accordion-options'>
                            {props.usernames.filter((user) => ((user.name !== undefined && (user.name !== constants.logout && user.name !== constants.addUsername)) && 
                            user.type !== constants.separator)).map((user, index) => (                             
                                 <AccordionDetails key={index} className='menu-option'>   
                                    <Box onClick={(event) => { user.action(event) }}>
                                    {user.style === 'bold' ? (<b>{user.name}</b>) : (user.name)}</Box>
                                </AccordionDetails>
                            ))}
                            {props.usernames.filter((user) => (user.name === constants.addUsername)).map((user, index) => (
                                <AccordionDetails key={index} className='menu-option'>
                                 <Link className='add-username' href='/add-user'>
                                    <AddIcon/>{user.name}
                                 </Link> 
                            </AccordionDetails>
                            ))}
                        </Box>
                    </Accordion>
            }     
                <Box className='mobile-accordion-container separator'>
                    <Accordion className='mobile-menu-accordion' expanded={expanded === -1}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon className={expanded === -1 ? 'expanded-menu' : 'collapsed-menu'} />}
                            className={expanded === -1 ? 'menu-title-expanded' : 'menu-title'}
                            onClick={() => toggleAccordion(-1)}>
                            {expanded === -1 ? (
                                <img src={require("../../common/assets/img/human-icon-blue-80.png")} alt="human-icon" className='menuImage' />
                            ) : (
                                <img src={require("../../common/assets/img/human-icon-blue.png")} alt="human-icon" className='menuImage' />
                            )}
                            Account
                        </AccordionSummary>
                        <Box className='accordion-options'>
                            <AccordionDetails className='menu-option'>
                                <Link href='/account-preferences'>Account preferences</Link>
                            </AccordionDetails>
                        </Box>
                    </Accordion>

                    {props.menu.map((menuOption, index) => (                        
                            <Accordion key={index} className='mobile-menu-accordion' expanded={expanded === index}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon className={expanded === index ? 'expanded-menu' : 'collapsed-menu'} />}
                                    className={expanded === index ? 'menu-title-expanded' : 'menu-title'}
                                    onClick={() => toggleAccordion(index)}>
                                    {menuOption.name}
                                </AccordionSummary>
                                <Box className='accordion-options'>
                                {menuOption.menuItems !== null && 
                                    menuOption.menuItems
                                        .filter((submenu) => submenu.name !== undefined && submenu.name !== 'Live chat')
                                        .map((submenu, idx) => 
                                            submenu.name.toLowerCase() === constants.policyDocumentsPortal ? (
                                                <form
                                                    key={idx}
                                                    name="input"
                                                    action={`${appSettings.AGENT_REDIRECT_URL}`}
                                                    method="post"
                                                    target="_blank"
                                                    ref={formRef}
                                                >
                                                    <input type="hidden" name="login" ref={inputRef} />
                                                    <AccordionDetails 
                                                        className='menu-option' 
                                                        onClick={handleSubmit}
                                                    >
                                                        {ReactHtmlParser(submenu.name)}
                                                    </AccordionDetails>
                                                </form>
                                            ) : (
                                                <AccordionDetails 
                                                    key={idx} 
                                                    className='menu-option' 
                                                    onClick={() => {
                                                        if (submenu.name.toLowerCase() === 'start a quote') {
                                                            handleMenuItemClick(submenu, index);
                                                            return;
                                                        }
                                                        if (submenu.name.toLowerCase() === constants.goToAmsuite) {
                                                            handleNavigate();
                                                            return;
                                                        }
                                                        else if (submenu.action !== undefined) {
                                                            submenu.action(submenu.link);
                                                            props.toggleSidebar();
                                                        }
                                                        else if (submenu.link !== '') {
                                                            window.open(submenu.link, submenu.open);
                                                            toggleAccordion(index);
                                                            props.toggleSidebar();
                                                        } 
                                                    }}
                                                >
                                                    {ReactHtmlParser(submenu.name)}
                                                </AccordionDetails>
                                            )
                                        )
                                }
                            </Box>
                            </Accordion>
                        ))}

                    <Box className='menu-live-chat' onClick={() => { handleToggles(); }}>
                        <img src={require('../../common/assets/img/livechat.png')} alt="livechat" />
                        Chat
                    </Box>
                </Box>
                </>
            }
            </Box>
            {(props.usernames && props.usernames.length > 0) && 

            <Box className='mobile-fixed-section separator'>
                <Button
                    disableRipple
                    onClick={logout}
                    className='logout-button'
                >
                    Log out
                </Button>
            </Box>
            }
        </Drawer>
    );
}

export default MobileMenuButton;
